import axios from "axios";
const Report = async (Companyid) => {
  const re = await axios
    .post(`https://api.sitimm.org/api/reports/show`, {
      reportNumber: 1,
      params: {
        companyId: Companyid,
      },
    })
    .then((res) => {
      console.log(res);
      console.log(res.data);
      return res;
    });
  return re;
};

export default Report;
